import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import ImageCropper from "../crop_image/ImageCropper";
import Swal from "sweetalert2";

function RecruitEdit() {
    const navigate = useNavigate();
    const { id_recruit } = useParams();

    const [formValue, setFormValue] = useState({
        images: null,
        link: "",
        tanggal: "",
    });

    const [preview, setPreview] = useState({
        images: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    useEffect(() => {
        if (id_recruit) {
            fetchRecruitData(id_recruit);
        }
    }, [id_recruit]);

    const fetchRecruitData = async (id_recruit) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/recruit/readRecruitById/${id_recruit}`
            );
            const data = response.data;

            setFormValue({
                images: data.images,
                link: data.link,
                tanggal: data.tanggal.split("T")[0],
            });

            if (data.images) {
                setPreview({
                    images: data.images,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            Swal.fire({
                title: "Error",
                text: "Gagal memuat data.",
                icon: "error",
            });
        }
    };

    const openCropper = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType: "images",
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setFormValue({
                ...formValue,
                images: croppedImage,
            });
            setPreview({
                ...preview,
                images: blobUrl,
            });
            closeCropper();
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
    };

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file);
        } else {
            setFormValue({
                ...formValue,
                [name]: value,
            });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { images, link, tanggal } = formValue;

        if (!images || !link || !tanggal) {
            Swal.fire({
                title: "Error",
                text: "Foto, link, dan tanggal harus diisi",
                icon: "error",
            });
            return;
        }

        const FormDataInput = new FormData();
        FormDataInput.append("image", images);
        FormDataInput.append("link", link);
        FormDataInput.append("tanggal", tanggal);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = `Bearer ${token}`;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );

            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/recruit/updateRecruit/${id_recruit}`,
                FormDataInput,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            Swal.fire({
                title: "Success",
                text: "Data berhasil diperbarui",
                icon: "success",
            });
            navigate("/recruit");
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Data gagal diperbarui",
                icon: "error",
            });
        }
    };

    return (
        <div className="wrapper recruitment-main">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Recruitment</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit Recruitment</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Foto</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="images"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto"
                                                        onChange={handleChange}
                                                    />
                                                    {preview.images && (
                                                        <div className="preview-container-gallery">
                                                            <img
                                                                src={preview.images}
                                                                alt="Preview"
                                                                className="preview-image-gallery"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Link</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="link"
                                                        placeholder="Masukkan link"
                                                        value={formValue.link}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Tanggal</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="tanggal"
                                                        value={formValue.tanggal}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/recruit">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                        {cropData.isOpen && (
                                            <ImageCropper
                                                imageSrc={cropData.imageSrc}
                                                setCroppedImage={setCroppedImage}
                                                onCropComplete={applyCrop}
                                                onClose={closeCropper}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default RecruitEdit;
